import { defineStore } from "pinia";
import {
  getListLocation,
  getDetailCampaignApi,
  getSpaceList,
  getListRoleBannerApi,
  getDetailRoleBannerApi
} from "@/admin/api";

const useSpaceAdmin = defineStore("admin-space", {
  state: () => ({
    spaceList: [],
    listLocation: [],
    isLoading: false,
    detailSpace: {},
    detailCampaign: {},
    campaignSpaceList: [],
    spaceOptions: [],
    roleBannerData: {},
    listRoleBanner: [],
    detailRoleBanner: {}
  }),
  getters: {
    getListLocation: (state) => state.listLocation,
    getLoadingStatus: (state) => state.isLoading,
  },
  actions: {
    async fetchSpaceList() {
      const { data } = await getSpaceList();
      this.spaceList = data.data;
      this.spaceOptions = data.data.map((space) => {
        return {
          title: space.generalBasicSpaceNameJa,
          id: space.id,
          value: space.id,
        };
      });
    },
    async fetchListLocation() {
      const res = await getListLocation();
      this.listLocation = res.data;
    },
    async fetchDetailCampaign(id) {
      const { data } = await getDetailCampaignApi(id);
      const { ts_campaign_space, ...detail } = data;
      this.detailCampaign = detail;
      this.campaignSpaceList = ts_campaign_space;
    },
    async fetchListRoleBanner(params) {
      const res = await getListRoleBannerApi(params);
      this.roleBannerData = res.data;
      this.listRoleBanner = res.data.data;
    },
    async fetchDetailRoleBanner(id) {
      const res = await getDetailRoleBannerApi(id);
      this.detailRoleBanner= res.data;
    },
  },
});
export default useSpaceAdmin;
